import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { MdDelete } from 'react-icons/md';

// Global Types
import { MyTimesheetEntriesProps } from 'services/myTimesheetEntries/types';

// @ts-ignore
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';

import { AppState } from 'services/types';

type OwnProps = MyTimesheetEntriesProps;

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & DispatchProps;

export class MyTimesheetEntriesDeleteButton extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { myTimesheetEntryUuid, updateQueryString } = this.props;

        updateQueryString({
            selectedEntry: myTimesheetEntryUuid,
            myTimesheetEntriesDeleteModal: true
        });
    };

    render(): React.ReactElement {
        return (
            <Button
                type="button"
                icon
                circular
                compact
                onClick={this.handleClick}
            >
                <MdDelete size="22" />
            </Button>
        );
    }
}

export default connect<AppState, DispatchProps>(
    null,
    { updateQueryString: updateQueryStringAction }
)(MyTimesheetEntriesDeleteButton);
